import { API_URL } from "@/configs/config"
import ky, { type Options } from "ky"
import { useUserStore } from "@/stores/userStore"
import { antdUtils } from "../antdUtil"

const defaultConfig: Options = {
  baseUrl: `${API_URL}`,
  timeout: 60000,
  hooks: {
    beforeRequest: [
      ({ request }) => {
        // Tự động thêm Access Token vào request header nếu có
        const token = useUserStore.getState().token
        if (token) {
          request.headers.set("Authorization", `Bearer ${token}`)
          request.headers.set("x-access-token", `${token}`)
        }
      },
    ],
    afterResponse: [
      async ({ response }) => {
        if (!response.ok) {
          // 1. Xử lý lỗi hệ thống/xác thực 401 (Unauthorized)
          if (response.status === 401) {
            const userStore = useUserStore.getState()
            antdUtils.modal?.error({
              title: "Thông tin đăng nhập không hợp lệ",
              content: "Thông tin xác thực đã hết hạn hoặc không hợp lệ, vui lòng đăng nhập lại.",
              okText: "Xác nhận",
              onOk() {
                userStore.logout()
                window.location.href = "/login"
              },
            })
            return
          }

          // 2. Xử lý các lỗi HTTP khác (400, 403, 500, v.v...)
          let errMessage = ""
          try {
            // Dùng .clone() để tránh làm cạn stream đọc body của response
            const errorData = (await response.clone().json()) as any
            errMessage = errorData?.message || `Đã xảy ra lỗi hệ thống (Mã lỗi: ${response.status})`
          } catch {
            errMessage = `Không thể kết nối hoặc phản hồi không hợp lệ (${response.status})`
          }

          if (errMessage) {
            antdUtils.modal?.error({
              title: `Lỗi máy chủ (${response.status})`,
              content: errMessage,
              okText: "Xác nhận",
            })
          }
        }
      },
    ],
  },
}

export const HttpRequest = ky.create(defaultConfig)
